<template>
  <template v-for="locale of locales">
    <template v-if="locale.type === 'component'">
      <component :is="slots[locale.value]"></component>
    </template>
    <template v-else>{{ locale.value }}</template>
  </template>
</template>
<script lang="ts" setup>
import { onMounted, Ref, ref, useSlots } from 'vue';

interface Props {
  path: string;
}

interface Locale {
  type: string;
  value: string;
}

const slots = useSlots();
const props = defineProps<Props>();
const locales: Ref<Locale[]> = ref([] as Locale[]);

onMounted(() => {
  const seperatorMatch = props.path.split(/{(.+?)}/g);
  locales.value = seperatorMatch.map((key) => {
    if (Object.keys(slots).find((slot) => slot === key)) {
      return {
        type: 'component',
        value: key,
      };
    } else {
      return {
        type: 'text',
        value: key,
      };
    }
  });
});
</script>
<style lang="scss"></style>
